var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-0 pa-1 mr-1",attrs:{"icon":"","text":"","x-small":"","color":_vm.mode === 'light' ? 'white' : '#585858'},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"size":"15"}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-582b33a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/WindowHeaderButton.vue
// module id = null
// module chunks = 